import { useQuery } from 'react-query';
import { IPaginationParams } from 'services/types';
import { ISchoolBoardFilterParams } from 'services/SchoolBoard/types';
import {
  getAllSchoolBoardsByLicenseAsync,
  getAllSchoolBoardsByLicenseCountAsync,
  getSchoolBoardByIdAsync,
  getSchoolBoardReadsAsync,
} from 'services/SchoolBoard/index';
import { getUserId } from 'services/DefaultService';

const USER_ID = getUserId();

export const useGetAllSchoolBoardsByLicenseAsync = (
  pagination: IPaginationParams,
  filter: ISchoolBoardFilterParams,
) =>
  useQuery([`schoolBoards${pagination.pageNumber}`, pagination, USER_ID, filter], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllSchoolBoardsByLicenseAsync(pagination, filter),
  });

export const useGetAllSchoolBoardsByLicenseCountAsync = (
  pagination: IPaginationParams,
  filter: ISchoolBoardFilterParams,
) =>
  useQuery([`schoolBoardsCount${pagination.pageNumber}`, pagination, USER_ID, filter], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllSchoolBoardsByLicenseCountAsync(filter),
  });

export const useGetSchoolBoardByIdAsync = (id: number, enabled: boolean = true) =>
  useQuery([`schoolBoardDetail`, id, USER_ID], {
    queryFn: () => getSchoolBoardByIdAsync(id),
    enabled: enabled && !!id,
  });

export const useGetSchoolBoardReadsAsync = (id: number | undefined, isOpen: boolean = false) =>
  useQuery([`schoolBoardReads`, id, USER_ID], {
    queryFn: () => getSchoolBoardReadsAsync(id!),
    enabled: isOpen && !!id,
    staleTime: 0,
    cacheTime: 0,
  });